__turbopack_context__.v({
  "className": "montserrat_72d15525-module__VXDjJq__className",
  "variable": "montserrat_72d15525-module__VXDjJq__variable",
});
